<mt-icon
    name="regular-cog"
    class="neti-config-icon"
    :small="true"
    @click="onConfigOpen"
    v-tooltip="{
        message: $t('neti-config-icon.tooltipText'),
        width: 200,
        position: 'top'
    }"
    size="24px"
></mt-icon>